function WhyChooseUs() {
  const features = [
    {
      icon: "🔬",
      title: "Advanced Formula",
      description: "Scientifically developed formulas that deliver superior cleaning power"
    },
    {
      icon: "🌍",
      title: "Eco-Conscious",
      description: "Biodegradable ingredients that are safe for your family and the planet"
    },
    {
      icon: "💎",
      title: "Premium Quality",
      description: "Premium ingredients ensure long-lasting freshness and exceptional results"
    },
    {
      icon: "✅",
      title: "Trusted by Thousands",
      description: "Join thousands of satisfied customers who trust WaschenNPure daily"
    }
  ];

  return (
    <section className="why-choose-us">
      <div className="container">
        <h2>Why Choose WaschenNPure?</h2>
        <p className="section-subtitle">
          We're committed to delivering excellence in every bottle
        </p>
        <div className="features-grid">
          {features.map((feature, index) => (
            <div className="feature-card" key={index}>
              <div className="feature-icon">{feature.icon}</div>
              <h3>{feature.title}</h3>
              <p>{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default WhyChooseUs;
